import Vue from 'vue';
import VueRouter from 'vue-router'; // 引入vue-router
import Home from '@/components/Home.vue'; // 路由懒加载
import Aviso from '@/components/Aviso.vue'; // 路由懒加载
import Privacidad from '@/components/Privacidad.vue'; // 路由懒加载
import Soporte from '@/components/Soporte.vue'; // 路由懒加载
import Terminos from '@/components/Terminos.vue'; // 路由懒加载

Vue.use(VueRouter); // 在Vue中注册VueRouter

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/Cuenta',
    name: 'Cuenta',
    component: Aviso,
  },
  {
    path: '/Nosotros',
    name: 'Nosotros',
    component: Privacidad,
  },
  {
    path: '/Acuerdo',
    name: 'Acuerdo',
    component: Soporte,
  },
  {
    path: '/Terminos',
    name: 'Terminos',
    component: Terminos,
  },
];

const router = new VueRouter({
  mode: 'history', // 路由模式
  // mode: 'hash', // 路由模式
  routes,
});

export default router; //导出router
